const SET_PREFERENCES = 'PREFERENCES/SET_PREFERENCES'
// TODO: add more action types if necessary

export {
  // eslint-disable-next-line import/prefer-default-export
  SET_PREFERENCES,
  // TODO: export action types added later
}
